<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item label="账单月份">
					<el-date-picker
						v-model="filters.years"
						
						 type="year"
                         value-format="yyyy"
						 placeholder="选择年份"
						 :append-to-body="false"
					   />
					   --
				    <el-date-picker
						v-model="filters.months"
						
						 type="month"
						  format="M月"
                        value-format="MM"
						 placeholder="选择账单月份"
					   />
				</el-form-item>
				<el-form-item label="上游">
					<el-select 
						v-model="filters.scode" filterable placeholder="选择上游" class="h-m-select">
					  <el-option v-for="item in splist"
						:key="item.scode" :label="item.sname" v-model="item.scode">
					  </el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getLists">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="downXls">生成下载XLS</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="datalist" border stripe highlight-current-row v-loading="listLoading" width="500" height="500"
			:summary-method="formatXxfUp" show-summary>
			<el-table-column prop="month" label="时间" min-width="80"></el-table-column>
			<el-table-column prop="spname" label="信息" min-width="180">
				<template slot-scope="scope">
					<div>
						{{scope.row.spname+","+scope.row.cpcode+","+scope.row.cpname+","+scope.row.site+",,"+scope.row.is_dzd}}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="fcbl" label="比例" min-width="100"></el-table-column>
			<el-table-column prop="money" label="账单金额" min-width="100"></el-table-column>
			<el-table-column prop="submoney" label="核减金额" min-width="100"></el-table-column>
			<el-table-column prop="rev_money" label="结算金额" min-width="100"></el-table-column>
			<el-table-column label="操作" fixed="right" width="100">
				<template slot-scope="scope">
					<div>
						<el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
						<el-button type="text" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<!--工具条翻页-->

		<!--编辑界面-->
		<el-dialog :title="editformtitle" :visible.sync="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="100px" :rules="formRules" ref="editForm">
				<el-form-item label="时间" prop="month">
					<el-input v-model="editForm.month" placeholder="时间"></el-input>
				</el-form-item>
				<el-form-item label="渠道" prop="cpcode">
					<el-input v-model="editForm.cpcode" placeholder="渠道"></el-input>
				</el-form-item>
				<el-form-item label="名称" prop="cpname">
					<el-input v-model="editForm.cpname" placeholder="名称"></el-input>
				</el-form-item>
				<el-form-item label="比例" prop="fcbl">
					<el-input v-model="editForm.fcbl" placeholder="比例"></el-input>
				</el-form-item>
				<el-form-item label="账单金额" prop="money">
					<el-input v-model="editForm.money" placeholder="账单金额"></el-input>
				</el-form-item>
				<el-form-item label="核减金额" prop="submoney">
					<el-input v-model="editForm.submoney" placeholder="核减金额"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>
<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';
	export default {
		data() {
			return {
				filters:{
					years:'',months:'',scode:''
				},
				datalist: [],
				splist:[],
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
				/////////////Form 表单
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				formRules: {
				},
				//编辑界面数据
				editForm: {
					actionurl:'',sqlid:'',month:'',cpcode:'',cpname:'',fcbl:'',money:'',submoney:'',rev_money:''
				}
			}
		},
		methods: {
			getSpList(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'html_spinfo.query',
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.splist = res.data.datas;
					}
				});
				
			},
			getLists:function(){
				let para = {
					page: this.page,
					pagesize:this.pagesize,
					actionurl:'default/getListAll',
					scode:this.filters.scode,
					monthstr:this.filters.years+'-'+this.filters.months,
					sqlid:'html_cpzd.query'
				};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
				});
			},
			downXls:function(){
				let paras = "api/datas/createXls?years="+this.filters.years+"&months="+this.filters.months;
				console.log(paras);
				window.open(paras);
			},
			handleAdd:function(){
				this.$confirm('确认生成XLS账单吗?', '提示', {type: 'warning'}).then(() => {
					this.listLoading = true;
					let para = {
						actionurl:'datas/createXls',
						years:this.filters.years,
						months:this.filters.months,
					};
					delData(para).then((res) => {
						this.listLoading = false;
						this.$message({message: res.data.message,type: res.data.type});
						this.getLists();
					});
				}).catch(() => {});
			},
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				this.editForm = Object.assign({}, row);
				this.editForm.rev_money = (this.editForm.money - this.editForm.submoney)*this.editForm.fcbl*0.01;
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'html_cpzd.upt';
			},
			editSubmit:function(){
				let para = Object.assign({}, this.editForm);
				util.saveFunction(this,para);
			},
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
					this.listLoading = true;
					let para = {
						actionurl:'default/del',
						sqlid:'html_cpzd.del',
						id:row.id
					};
					delData(para).then((res) => {
						this.listLoading = false;
						this.$message({message: res.data.message,type: res.data.type});
						this.getLists();
					});
				}).catch(() => {});
			},
			formatXxfUp: function (param) {
				const { columns, data } = param;
				const sums = [];
				var noSumIndex = 2 ;				
				columns.forEach((column, index) => {
				  if (index <=noSumIndex || index==6) {
					return ;
				  }
				  //////////////////////
				  const values = data.map(item => Number(item[column.property]));
				  if (!values.every(value => isNaN(value))) {
					sums[index] = values.reduce((prev, curr) => {
					  const value = Number(curr);
					  if (!isNaN(value)) {
						return prev + curr;
					  } else {
						return prev;
					  }
					}, 0);
				  } else {
					sums[index] = 'N/A';
				  }
				});
				console.log('合计:'+sums[3]);
				sums[0] = '合计';
				return sums;
			}
		},
		mounted() {
			this.getSpList();
			this.getLists();
		}
	}	
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// cpDzd.vue?2386e374